/* import __COLOCATED_TEMPLATE__ from './team-multiselect.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';
import type Team from 'embercom/objects/inbox/inboxes/team';

interface Arguments {
  onTeamsChange: (selectedTeams: number[]) => void;
  teamType: string;
  selectedTeamIds: number[];
  eligibleTeams: any[];
}

interface Signature {
  Args: Arguments;
  Element: HTMLDivElement;
}

export default class TeamMultiselect extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare router: RouterService;
  @service declare appService: AppService;

  @action
  navigateToManageTeams(): void {
    this.router.transitionTo('apps.app.settings.helpdesk.teams', this.appService.app.id);
  }

  get footerActions() {
    return [
      {
        text: this.intl.t(
          'settings.teammates.invites.configuration.team-multiselect.manage-team-inboxes',
        ),
        icon: 'reference',
        action: this.navigateToManageTeams,
      },
    ];
  }

  get selectedTeams(): Team[] {
    return this.args.selectedTeamIds.map((teamId) =>
      this.appService.app.teams.find((team: any) => team.id === teamId.toString()),
    );
  }

  get selectedTeamsAsLabels(): any[] {
    let teams = this.selectedTeams;

    let labels = teams.map((team: any, index: number) => {
      return {
        name: team.name,
        model: team,
        isLast: index === teams.length - 1,
      };
    });
    return labels;
  }

  get hasSelectedTeams(): boolean {
    return this.args.selectedTeamIds.length > 0;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::Teammates::Invites::Configuration::TeamMultiselect': typeof TeamMultiselect;
    'settings/teammates/invites/configuration/team-multiselect': typeof TeamMultiselect;
  }
}
